import Vue from 'vue';
import VueRouter from 'vue-router';

import FTSLogin from "../administration/FTSLogin";
import Client from "../../Client";
import Studio from "../../Studio";
import Admin from "../../Admin";
import Builder from "../../Builder";
import ShareForm from "../../ShareForm";
import FTSDashboard from "../client/FTSDashboard";
import FTSCalendar from "../client/FTSCalendar";
import FTSRoutinePanel from "../routine/FTSRoutinePanel";
import FTSHtmlViewer from "../client/FTSHtmlViewer";
import FTSListView from "../elements/FTSListView";
import FTSUsers from "../client/FTSUsers";
import FTSConnections from "../client/FTSConnections";
import FTSSettings from "../settings/FTSSettings";
import FTSApps from "../client/FTSApps";
import FTSLobby from "../client/FTSLobby";
import FTSMobileSolution from "../mobile/FTSMobileSolution";
import FTSMobileFlowDiagram from "../mobile/FTSMobileFlowDiagram";
import FTSMobileChart from "../mobile/FTSMobileChart";
import FTSDevicePreview from "../device-preview/FTSDevicePreview";
import External from "../external/External";
import FTSAuthCallback from "../administration/FTSAuthCallback";
import PortalLaunch from "../portals/PortalLaunch";

import Lite from "../../Lite";
import LiteListView from "../elements/views/FTSListView";
import LiteDevicePreview from "../../components/lite/FTSDevicePreview";
import LiteUsers from "../../components/lite/FTSUsers";
import OnboardingView from "../elements/views/FTSOnboarding.vue";
import LiteModuleHub from "../../components/lite/FTSModuleHub";
import LiteLobby from "../../components/lite/FTSLobby";

import FTSTeammate from "../teammate/FTSTeammate";
import FTSApprovalRequest from "../approvals/FTSApprovalRequest";
import FTSOnboarding from '../elements/views/FTSOnboarding.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/login/:action?',
    name: 'login',
    component: FTSLogin,
    meta: {
      title: 'Sign in'
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: FTSLogin
  },
  {
    path: '/join',
    name: 'join',
    component: FTSLogin,
  },
  {
    path: '/activate',
    name: 'activate',
    component: FTSLogin,
    meta: {
      title: 'Activation'
    }
  },
  {
    // Email verification landings: the "Verify and continue" link in the sign-up code email
    // (?id&t) and the legacy verification link (?email&code) that the server has emailed for
    // years without a client route to land on. See docs/identity-email-verification-proposal.md.
    path: '/verify',
    name: 'verify',
    component: FTSLogin,
    meta: {
      title: 'Verify your email'
    }
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: FTSLogin,
    meta: {
      title: 'Verify your email'
    }
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: FTSLogin,
    meta: {
      title: 'Reset password'
    }
  },
  {
    path: '/reset',
    name: 'reset',
    component: FTSLogin,
    meta: {
      title: 'Set new password'
    }
  },
  {
    path: '/createAccount/:action?',
    name: 'createAccount',
    component: FTSLogin,
    meta: {
      title: 'Sign up'
    }
  },
  {
    path: '/authcallback',
    name: 'auth-callback',
    component: FTSAuthCallback,
    meta: {
      title: 'Authenticating'
    }
  },
  {
    path: '/setup-workspace/:version?',
    name: 'setup-workspace',
    component: FTSOnboarding,
    meta: {
      title: 'Setup a new workspace',
      requiresAuth: true
    }
  },
  {
    path: '/create-workspace/:version?',
    name: 'create-workspace',
    component: FTSOnboarding,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mobile-solution',
    name: 'mobile-solution',
    component: FTSMobileSolution,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mobile-flow-diagram',
    name: 'mobile-flow-diagram',
    component: FTSMobileFlowDiagram,
    meta: {
      external: true
    }
  },
  {
    path: '/mobile-chart',
    name: 'mobile-chart',
    component: FTSMobileChart,
    meta: {
      external: true
    }
  },
  {
    path: '/preview',
    name: 'device-preview',
    component: FTSDevicePreview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/external',
    name: 'external',
    component: External,
    meta: {
      external: true,
      requiresAuth: true
    }
  },
  // Portal links: the bounce page a side-menu click opens in a new tab, and the portal's permanent
  // link. No shell. Signed out, main.js keeps a return-to through the login page for this route only
  // (docs/integration-portal-link-proposal.md §4.4 in the SVN repo).
  {
    path: '/portal/:id',
    name: 'portal',
    component: PortalLaunch,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/client',
    name: 'client',
    component: Client,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: FTSDashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/calendar',
        name: 'calendar',
        component: FTSCalendar,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/routines',
        name: 'routines',
        component: FTSRoutinePanel,
        meta: {
          requiresAuth: true,
          requiresInternal: true
        }
      },
      {
        path: '/htmlViewer',
        name: 'htmlViewer',
        component: FTSHtmlViewer,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/list/:moduleId',
        name: 'list-view',
        component: FTSListView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/users',
        name: 'users',
        component: FTSUsers,
        meta: {
          requiresAuth: true,
          group: "users"
        }
      },
      {
        path: '/users/inactive',
        name: 'users-inactive',
        component: FTSUsers,
        meta: {
          requiresAuth: true,
          group: "users"
        }
      },
      {
        path: '/users/invitation',
        name: 'users-invitation',
        component: FTSUsers,
        meta: {
          requiresAuth: true,
          group: "users"
        }
      },
      {
        path: '/users/lobby',
        name: 'users-lobby',
        component: FTSUsers,
        meta: {
          requiresAuth: true,
          group: "users"
        }
      },
      {
        // Workspace settings (docs/frontend-workspace-settings-proposal.md).
        // requiresStage is the W-25 release gate: components/settings/settingsStage.js
        // decides who is inside the current stage (GA since 2026-09-30, so only the
        // kill switch shuts it). Anyone outside it lands on the dashboard with the old
        // dialog available. The /users routes and /connections redirect in here
        // (settingsNav FOLDED_ROUTES) while their section is open.
        path: '/settings/:section?',
        name: 'settings',
        component: FTSSettings,
        meta: {
          requiresAuth: true,
          requiresStage: 'settings',
          group: "settings"
        }
      },
      {
        path: '/connections',
        name: 'connections',
        component: FTSConnections,
        // Internal access only for now: availability is also seat-tier based
        // (pricing gate) and the backend enforces, but while the feature rolls
        // out we keep it restricted to internal staff.
        meta: {
          requiresAuth: true,
          requiresInternal: true
        }
      },
      {
        path: '/apps',
        name: 'apps',
        component: FTSApps,
        // Module Store apps (SS05963), alpha: internal staff only while the
        // feature soaks; the backend admin-gates install/config regardless.
        meta: {
          requiresAuth: true,
          requiresInternal: true
        }
      },
      {
        path: '/lobby',
        name: 'lobby',
        component: FTSLobby,
        meta: {
          requiresAuth: true
        }
      },
      {
        // An AI-prepared activity waiting for this person's approval
        // (docs/teammate-human-approval-request-proposal.md).
        path: '/approvals/:id',
        name: 'approval-request',
        component: FTSApprovalRequest,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/client',
        redirect: '/dashboard'
      }
    ]
  },
  {
    path: '/studio',
    name: 'studio',
    component: Studio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/builder',
    name: 'builder',
    component: Builder,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/lite-home',
    name: 'lite-home',
    component: Lite,
    children: [
      {
        path: '/lite/studio/:moduleId?/',
        name: 'lite-studio',
        component: LiteListView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/lite/preview/:moduleId?/',
        name: 'lite-preview',
        component: LiteDevicePreview,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/lite/users',
        name: 'lite-users',
        component: LiteUsers,
        meta: {
          requiresAuth: true,
          group: 'users'
        }
      },
      {
        path: '/lite/users/inactive',
        name: 'lite-users-inactive',
        component: LiteUsers,
        meta: {
          requiresAuth: true,
          group: 'users'
        }
      },
      {
        path: '/lite/users/lobby',
        name: 'lite-users-lobby',
        component: LiteUsers,
        meta: {
          requiresAuth: true,
          group: 'users'
        }
      },
      {
        path: '/lite/lobby',
        name: 'lite-lobby',
        component: LiteLobby,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/lite/module-hub',
        name: 'lite-module-hub',
        component: LiteModuleHub,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/lite/:moduleId?/',
        name: 'lite',
        component: LiteListView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/lite-home',
        redirect: '/lite'
      }
    ]
  },
  {
    path: '/share/:id?',
    name: 'shareForm',
    component: ShareForm,
  },
  {
    path: '/teammate',
    name: 'teammate',
    component: FTSTeammate,
    meta: {
      title: 'AI Teammate',
      requiresAuth: true
    }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

/* avoided redundant navigation to current location (NavigationDuplicated) */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default routes;